/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import { useLocalStorage } from '@/hooks/common'
import useAppStore from '@/store/useAppStore'

export const useUploadMedia = () => {
  const [basicInfo] = useLocalStorage('ewBasicInfo', null)
  // See useUploadProfilePicture — the reactive store catches up even when this
  // component-scoped localStorage cache was read before basic info had loaded.
  const storeContainerID = useAppStore((state) => state.user.profile?.mobileContID)
  const containerID = storeContainerID || basicInfo?.mobileContID || ''
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.UPLOAD_MEDIA, containerID],
    mutationFn: async (image: string | Blob) => {
      if (!containerID) {
        throw new Error('User must be authenticated to upload media')
      }
      const formData = new FormData()
      formData.append('egowallFileUpload', image)
      formData.append('fileUploadName', 'egowallFileUpload')
      formData.append('fileType', '1')
      formData.append('uploadContainerID', containerID)
      formData.append('format', 'json')
      const response = await axios.api.post('ego/upload-object', formData)
      return response.data.fileInfo
    },
  })
}
